import { CmsObjectWithDefault } from '@components/Cms/types';

export type SignupPanelCmsKey = 'SignUpTitle' | 'AlreadyHaveAccount' | 'BackToSignIn' | 'OrContinueWith';

export const SignupPanelCmsWithDefault: CmsObjectWithDefault<SignupPanelCmsKey> = {
    SignUpTitle: {
        cmsId: 76297,
        defaultTranslation: 'Sign up',
    },
    AlreadyHaveAccount: {
        cmsId: 63803,
        defaultTranslation: 'Already have an account? {0}',
    },
    BackToSignIn: {
        cmsId: 67377,
        defaultTranslation: 'Sign in',
    },
    OrContinueWith: {
        cmsId: 109024,
        defaultTranslation: 'or continue with',
    },
};
